import {
  EvaluationRoutineLink,
  FileMetadata,
} from "../../gen/api";
import React from "react";
import LinksEdit from "../LinksEdit/LinksEdit";
import FilesEdit from "../Files/FilesEdit";

type Props = {
    evaluationRoutineLink: EvaluationRoutineLink[]

    handleNewEvaluationRoutineLinkSubmit: (evaluationRoutineLink: EvaluationRoutineLink) => void
    handleDeleteEvaluationRoutineLink: (evaluationRoutineLink: EvaluationRoutineLink) => void

  evaluationRoutines: FileMetadata[]
  handleNewEvaluationRoutineSubmit: (evaluationRoutine: FileMetadata) => void
  handleDeleteEvaluationRoutine: (evaluationRoutineId: string) => void
}

function EvaluationRoutineEdit({
                                   evaluationRoutineLink,
                                   handleNewEvaluationRoutineLinkSubmit,
                                   handleDeleteEvaluationRoutineLink,
                                 evaluationRoutines,
                                 handleNewEvaluationRoutineSubmit,
                                 handleDeleteEvaluationRoutine
                               }: Props) {

  return (
      <>
          <LinksEdit links={evaluationRoutineLink} handleNewLinkSubmit={handleNewEvaluationRoutineLinkSubmit} handleDeleteLink={handleDeleteEvaluationRoutineLink}></LinksEdit>
          <FilesEdit forms={evaluationRoutines} handleNewFormSubmit={handleNewEvaluationRoutineSubmit} handleDeleteForm={handleDeleteEvaluationRoutine}></FilesEdit>
      </>
  );
}

export default EvaluationRoutineEdit;